import { historyMinuteBucketKey } from './formatChangeHistoryDate';
import type { HistoryChangeSetGroup, HistoryGroupableEntry } from './types';

const GROUP_KEY_SEP = '\x1f';

function uiGroupKey(item: HistoryGroupableEntry): string {
  return `${item.display_actor}${GROUP_KEY_SEP}${historyMinuteBucketKey(item.occurred_at)}`;
}

/**
 * Groups history rows: one card per user per calendar minute (local display time).
 * Preserves server sort order (newest groups first).
 */
export function groupHistoryByChangeSet<T extends HistoryGroupableEntry>(
  items: T[]
): HistoryChangeSetGroup<T>[] {
  const order: string[] = [];
  const map = new Map<string, HistoryChangeSetGroup<T>>();

  for (const item of items) {
    const key = uiGroupKey(item);
    let group = map.get(key);
    if (!group) {
      group = {
        group_key: key,
        occurred_at: item.occurred_at,
        display_actor: item.display_actor,
        items: [],
      };
      map.set(key, group);
      order.push(key);
    }
    group.items.push(item);
  }

  return order.map((key) => map.get(key)!);
}
